import type { ThemeVariantMap } from "@/theme/types";

import { forumcinemasDarkTheme } from "./forumcinemas.dark";
import { forumcinemasLightTheme } from "./forumcinemas.light";

export const forumcinemasTheme: ThemeVariantMap = {
  DARK: forumcinemasDarkTheme,
  LIGHT: forumcinemasLightTheme,
} as const;
